// axios
import axios, { type AxiosRequestConfig, type AxiosResponse } from 'axios';

const functionConfig: Partial<AxiosRequestConfig> = {
  baseURL: import.meta.env.VITE_APP_AZ_FUNCTIONS_BASE_URI,
  withCredentials: true
};

/**
 * Makes a request to an azure function for authentication.
 * @param {AxiosRequestConfig} requestConfig Axios request config. Only the `url` is required. For all available options see https://axios-http.com/docs/req_config.
 */
const callAzureFunctionAuth = async <T = unknown,>(requestConfig: AxiosRequestConfig): Promise<AxiosResponse<T>> =>
  axios<T>({
    ...requestConfig,
    ...functionConfig
  });

export default callAzureFunctionAuth;
